import type React from 'react';

import { Image, Text } from '@change/ds-core-ui';

import { TypedTranslate } from '@change-corgi/core-react/i18n';

import type { WhoUsesCardType } from '#src/app/pages/about/main/shared/types';

export const WhoUsesCard: React.FC<WhoUsesCardType> = ({ icon, title, description }) => {
	return (
		<div className="flex gap-4 py-4 md:px-4">
			<Image src={icon} alt="" className="h-14 w-14 shrink-0" />
			<div>
				<Text as="h4" variant="heading" size="x-small">
					<TypedTranslate value={title} />
				</Text>
				<Text as="p" className="mt-2">
					<TypedTranslate value={description} />
				</Text>
			</div>
		</div>
	);
};
